import React, { useState, useEffect } from "react";
import GuestHeader from "./GuestHeader";
import GuestFooter from "./GuestFooter";

function GuestHolyBook() {
    const [iframeUrl, setIframeUrl] = useState("https://api.morbaseliosjsocderby.org/pdf/test.pdf");

    const calculateIframeUrl = () => {
        const viewportWidth = window.innerWidth;
        // Use the PDF viewer URL - update with your actual viewer if needed
        setIframeUrl("https://api.morbaseliosjsocderby.org/pdf/test.pdf");
    };

    useEffect(() => {
        // Calculate URL on load
        calculateIframeUrl();

        // Add event listener for window resize
        window.addEventListener("resize", calculateIframeUrl);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener("resize", calculateIframeUrl);
        };
    }, []);

    return (
        <>
            <GuestHeader />
            <section className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <iframe
                            src={iframeUrl}
                            style={{
                                width: '100%',
                                height: '85vh',
                                border: "none",
                            }}
                            title="Holy Book Viewer"
                        ></iframe>
                    </div>
                </div>
            </section>
            <GuestFooter />
        </>
    );
}

export default GuestHolyBook;
